import { render, staticRenderFns } from "./needDetail.vue?vue&type=template&id=183d5832"
import script from "./needDetail.vue?vue&type=script&lang=js"
export * from "./needDetail.vue?vue&type=script&lang=js"
import style0 from "./needDetail.vue?vue&type=style&index=0&id=183d5832&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports